import { isNumber } from "util"

const validate = (props) => {
    const errors = {}
    if (!props.name) {
        errors.name = {
            ar: ' يرجى ادخال الاسم ',
            en: 'Enter your name'
        }
    }
    // if ((Number(props.name))) {
    //     errors.name = {
    //         ar: ' يرجى ادخال رقم الهاتف صحيحا ',
    //         en: 'Enter correct phone number'
    //     }
    // } 
    if (!props.email) {
        errors.email = {
            ar: 'يرجى ادخال البريد الالكتروني',
            en: 'Enter your email'
        }
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(props.email)) {
        errors.email = {
            ar: 'البريد الالكتروني غير صحيح',
            en: 'invalid email'
        }
    }
    if (!props.password) {
        errors.password = {
            ar: ' يرجى ادخال كلمة المرور',
            en: 'Enter your password'
        }
    } 
    if (!props.phone) {
        errors.phone = {
            ar: ' يرجى ادخال رقم الهاتف ',
            en: 'Enter your phone'
        }
    } 
    if (!(Number(props.phone))) {
        errors.phone = {
            ar: ' يرجى ادخال رقم الهاتف صحيحا ',
            en: 'Enter correct phone number'
        }
    } 
    if (props.password !== props.confirmpassword) {
        errors.confirmpassword = {
            ar: ' كلمة المرور غير متطابقة',
            en: 'Password does not match'
        }
    } 

    return errors
}

export default validate;